import { Card, Row, Col, Typography, Button, Space, Alert } from "antd"
import {
  WarningOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons"

const { Text } = Typography

const BottleNeckDetector = () => {
  // Bottleneck Data
  const bottleneckData = [
    {
      key: "1",
      issue: "Mitigation Plan stuck: Finance team hasn't approved vendor shift",
      duration: "7 days",
      severity: "high",
      impact: "$280K potential savings blocked",
      team: "Finance",
    },
    {
      key: "2",
      issue: "No follow-up after critical opportunity identified",
      duration: "3 days",
      severity: "medium",
      impact: "Market window closing",
      team: "Strategy",
    },
  ]

  return (
    <Card
        title={
          <Space>
            <WarningOutlined style={{ color: "#ff4d4f" }} />
            <span>Bottleneck Detector (Unique)</span>
          </Space>
        }
        style={{ marginBottom: "24px" }}
      >
        <Row gutter={[16, 16]}>
          {bottleneckData.map((bottleneck, index) => (
            <Col xs={24} lg={12} key={index}>
              <Alert
                message={
                  <Space direction="vertical" style={{ width: "100%" }}>
                    <Text strong>{bottleneck.issue}</Text>
                    <Space>
                      <ClockCircleOutlined />
                      <Text>Stalled for: {bottleneck.duration}</Text>
                    </Space>
                    <Space>
                      <Text>Impact: {bottleneck.impact}</Text>
                    </Space>
                    <Space>
                      <Button type="primary" size="small" danger>
                        Escalate
                      </Button>
                      <Button size="small">Reassign</Button>
                    </Space>
                  </Space>
                }
                type={bottleneck.severity === "high" ? "error" : "warning"}
                showIcon
              />
            </Col>
          ))}
        </Row>
      </Card>
  )
}

export default BottleNeckDetector